import React from "react";

export default function RasterCoverageSelector({
  coverages,
  checked,
  onChange,
  onSelect,
}) {
  return (
    <div>
      <label className="flex items-center font-normal text-xs space-x-1 mb-0">
        <input onChange={onChange} checked={!!checked} type="checkbox" />
        <div className="select-none">Satellite</div>
      </label>
      {checked && (
        <select onChange={(e) => onSelect(e.target.value)} className="p-1 mt-1 text-xs">
          <option key={-1} value={null}>
            Modern
          </option>

          {coverages.map((coverage) => (
            <option key={coverage.id} value={coverage.id}>
              {coverage.name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
